import { DashboardModel as Model } from './Model'


export const MODULE_NAME = 'dashboard-auth'

export const DASHBOARD_AUTH_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
} as const

export const MENU = {
  id: DASHBOARD_AUTH_ROUTES.LAYOUT,
  route: { name: DASHBOARD_AUTH_ROUTES.LAYOUT },
  label: Model.page_title.index,
  icon: 'mdi-view-dashboard',
} as const
